/** The form card: name, banner description, discount and schedule. */
import type { DateKey } from '../../../shared/date-time-range/date-keys';

import { formDiscount, isScheduleInOrder } from './campaign-form';
import { CampaignDescriptionSection } from './CampaignDescriptionSection';
import { CampaignDiscountSection } from './CampaignDiscountSection';
import { CampaignNameSection } from './CampaignNameSection';
import { CampaignScheduleSection } from './CampaignScheduleSection';
import type { CampaignEditor } from './use-campaign-editor';

import '../../shared/editor-page/editor-page.css';

export interface CampaignFormCardProps {
  editor: CampaignEditor;
  today: DateKey;
}

export function CampaignFormCard({ editor, today }: CampaignFormCardProps) {
  const { values, errors, set } = editor;
  const discount = formDiscount(values);
  const inOrder = isScheduleInOrder(values);
  return (
    <section className="nb-card nb-ed-form-card" aria-label="Campaign details">
      <CampaignNameSection
        value={values.name}
        error={errors.name}
        onChange={(name) => set({ name })}
      />
      <CampaignDescriptionSection
        value={values.description}
        discount={discount}
        error={errors.description}
        onChange={(description) => set({ description })}
      />
      <CampaignDiscountSection
        discountType={values.discountType}
        amount={values.amount}
        discount={discount}
        error={errors.amount}
        onChange={set}
      />
      <CampaignScheduleSection
        value={values.schedule}
        inOrder={inOrder}
        today={today}
        // The picker already says when the end is before the start; anything
        // else here came back from the server.
        error={inOrder ? errors.schedule : undefined}
        onChange={(schedule) => set({ schedule })}
      />
    </section>
  );
}
